<template>
  <div class="site-shell">
    <a class="skip-link" href="#main-content" @click.prevent="skipToContent">Skip to content</a>
    <Navbar />

    <main id="main-content" tabindex="-1">
      <router-view />
    </main>

    <footer class="site-footer">
      <div class="footer-inner">
        <img class="footer-mark" src="@/assets/images/name_logo.png" alt="Fathom Ocean">

        <div class="footer-grid">
          <section aria-labelledby="footer-company">
            <h2 id="footer-company">Fathom Ocean</h2>
            <p>
              Temecula, CA, 92592 <br>
              Boulder, CO, 80301 <br>
              United States <br>
              <a href="mailto:trevor@fathomocean.com">trevor@fathomocean.com</a> <br>
              <a href="tel:+17203528507">1-720-352-8507</a> <br>
              <a href="mailto:amy@fathomocean.com">amy@fathomocean.com</a> <br>
              <a href="tel:+13035961398">1-303-596-1398</a> <br>
              <a href="mailto:info@fathomocean.com">info@fathomocean.com</a>
            </p>
          </section>

          <section aria-labelledby="footer-about">
            <h2 id="footer-about">About</h2>
            <p>
              <router-link to="/about">Our Team </router-link><br>
              <router-link to="/resources#faq">FAQ</router-link>
            </p>
          </section>

          <section aria-labelledby="footer-support">
            <h2 id="footer-support">Support</h2>
            <p>
              <router-link to="/contact">Customer Support </router-link><br>
              <router-link to="/terms">Purchasing Terms</router-link><br>
              <router-link to="/warranty">Warranty &amp; Repair</router-link>
            </p>
          </section>
        </div>

        <div class="footer-rule" aria-hidden="true"></div>
      </div>
    </footer>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { createSiteMotion } from '@/utils/siteMotion'

export default {
  name: 'Home',
  components: {
    Navbar,
  },
  watch: {
    '$route.fullPath'() {
      this.$nextTick(() => {
        if (this._siteMotion) this._siteMotion.refresh()
      })
    },
  },
  mounted() {
    this._siteMotion = createSiteMotion(this.$el)
    this.$nextTick(() => this._siteMotion.refresh())
  },
  beforeDestroy() {
    if (this._siteMotion) this._siteMotion.destroy()
  },
  methods: {
    skipToContent() {
      const main = document.getElementById('main-content')
      if (!main) return
      main.focus({ preventScroll: true })
      main.scrollIntoView({ behavior: 'auto', block: 'start' })
    },
  },
}
</script>
